import { render, staticRenderFns } from "./SpkbHistory.vue?vue&type=template&id=e4e908ac&"
import script from "./SpkbHistory.vue?vue&type=script&lang=js&"
export * from "./SpkbHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports